module.exports = __webpack_public_path__ + "img/ru_Ecran 6.00ea2975.png";